export default {
  "content": "<path d=\"M22 1.438H1M22 9.313H1M22 17.188H1\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/>",
  "attrs": {
    "viewBox": "0 0 23 19",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};